import { __decorate } from "tslib";
import 'echarts/theme/macarons.js'; // Theme used in BarChart, LineChart, PieChart and RadarChart
import { Component, Vue } from 'vue-property-decorator';
import PanelGroup from './components/PanelGroup.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'DashboardAgent',
  components: {
    PanelGroup
  }
})], default_1);
export default default_1;